export const PAYMENT_CURRENCIES = [
  {
    label: 'EUR',
    value: 'EUR',
  },
];
